import { Logger } from '@feature-hub/core';

export function createConsumerLogger(consumerId: string): Logger {
  const prefixArgs = [`%c${consumerId}`, 'font-weight: bold'];

  return {
    trace: console.trace.bind(console, ...prefixArgs),
    debug: console.debug.bind(console, ...prefixArgs),
    info: console.info.bind(console, ...prefixArgs),
    warn: console.warn.bind(console, ...prefixArgs),
    error: console.error.bind(console, ...prefixArgs),
  };
}
